module.exports = __webpack_public_path__ + "img/logo_xiuye_hf@2x_change.79612d4a.png";